import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { chain } from 'lodash';

import { IManualAuditRuleReport } from '../../../../../../../../shared/interfaces/audit-reports/audit-report.interface';
import { $severity } from '../../../../../../../../shared/constants/accessibility';
import { ISuccessCriteria } from '../../../../../../../../shared/audits/definitions/success-criteria/success-criteria.interface';
import { $successCriteria } from '../../../../../../../../shared/audits/definitions/success-criteria/constants';

@Component({
  selector: 'app-manual-rule-details',
  templateUrl: './manual-rule-details.component.html',
  styleUrls: ['./manual-rule-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ManualRuleDetailsComponent {
  @Input()
  public ruleReport: IManualAuditRuleReport;
  public $severity: typeof $severity = $severity;

  constructor() {}

  public get successCriterias(): string[] {
    return chain(this.ruleReport.successCriterias)
      .sortBy((criterion: ISuccessCriteria) => {
        const [major, minor, release] = criterion[$successCriteria.num]?.split('.')?.map(Number);
        return [major, minor, release]; // Return array of numbers for sorting
      })
      .map((criteria: ISuccessCriteria): string => `${criteria.num} - ${criteria.handle}`)
      .uniq()
      .value();
  }
}
